<p>Here’s a List of Data Products Our Platform Offers</p>
<div class="productsGrid">
    <div id="tour-productCard-{{i}}" class="productCard" *ngFor="let module of getinsightsModules; let i = index">
        <img [src]="(moduleByteMap[module.moduleName] 
                || moduleByteMap['Tyre Pairing']) | base64: 'image/png'" [alt]="module.moduleName" class="prodImg">
        <div class="productDetailsCont">
            <h3 class="prodName">{{ module.moduleName }}</h3>
            <button *ngIf="false" class="bookmarkBtn"><img src="/assets/images/bookmarksIcon.svg" alt=""></button>
        </div>
        <div class="productDetailsCont">
                <p class="prodDesc">{{ module.moduleShortDescription }}</p>
                <div></div>
            </div>
            <div class="reportsCount" [ngClass]="{ hasReports: module.subscription && userId && isUserLoggedIn && module.totalReportCount > 0}">
                <ng-container *ngIf="module.subscription && userId && isUserLoggedIn && module.totalReportCount > 0">
                    <p class="totalReports">
                    Total Reports: <span class="count">{{ module.totalReportCount }}</span>
                    </p>
                </ng-container>
            </div>
            <!-- <div style="height: 100%" *ngIf="!module.subscription"></div> -->
            <div class="twoBtns">
                    <p class="tag new justStart" *ngIf="module.moduleLink == ''">Coming Soon</p>
                    <button class="secondary" *ngIf="!userId && !isUserLoggedIn&&module.moduleLink" (click)="onSignIn()">
                    <img src="/assets/images/locked.svg" alt="">
                        Request Access
                    </button>
                    <button class="secondary" *ngIf="module.subscription == false&&module.moduleLink&& module.accessCompleted == undefined &&userId &&isUserLoggedIn" (click)="module.moduleName=='Data Quest' || module.moduleName=='Tyre Pairing'|| module.moduleName=='Parsing & Mapping'|| module.moduleName=='RaMU' ? onRequestAccessClick(module) : onSubscribe()">
                        <img src="/assets/images/locked.svg" alt="">
                        Request Access
                    </button>
                    <button class="secondary" *ngIf="module.subscription == false&& module.accessCompleted != undefined && module.accessCompleted == false && userId &&isUserLoggedIn"
                                        (click)="onAccessPending()">
                        <img src="/assets/images/locked.svg" alt="" />
                        Access Pending
                    </button>
                    <button class="primary" *ngIf="module.subscription && userId && isUserLoggedIn" (click)="onPairingApicall(module.moduleLink)">
                        Open Product
                    </button>
                    <button class="dmintLinkBtn" (click)="viewDetails(module)">
                        View Details
                    </button>
             </div>
    </div>
</div>
<app-success-toast [message]="successMessage" *ngIf="successMessage"></app-success-toast>

<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandlerSub()"></app-alert>